/* Uta Meinke - Groessenassistent. Popup ueber die Schaltflaeche neben der Groessenwahl.
   Hinweis: runde Klammern in den HTML-Strings werden vor dem Einfuegen zu Anfuehrungszeichen. */
(function () {
  'use strict';

  var MAIL = 'info@utameinke.com';
  var LETTERS = ['XS','S','M','L','XL','XXL','3XL'];
  var NUM_DAMEN = [34,36,38,42,44,46,48];
  var NUM_HERREN = [44,46,48,52,54,56,58];

  var modal = null, chosen = null;
  var ctx = { gender:'damen', category:'oberteil', optionIndex:'option1' };
  var state = { statur:'normal', passform:'normal' };

  function q(s){ return s.replace(/\(/g, String.fromCharCode(34)).replace(/\)/g, String.fromCharCode(34)); }
  function h(html){ var d = document.createElement('div'); d.innerHTML = q(html); return d.firstElementChild; }

  function letterIndex(bmi, gender){
    var b = (gender === 'herren') ? [20,22.5,25.5,28.5,32] : [19,21.5,24.5,28,32];
    var i = 0;
    while (i < b.length && bmi >= b[i]) i++;
    return i;
  }

  function recommend(cm, kg){
    var m = cm / 100, bmi = kg / (m * m);
    var i = letterIndex(bmi, ctx.gender);
    if (state.statur === 'kraeftig') i += 1;
    if (state.statur === 'zierlich') i -= 1;
    if (state.passform === 'locker') i += 1;
    if (state.passform === 'eng') i -= 1;
    if (ctx.category === 'jacke') i += 1;
    return Math.max(0, Math.min(LETTERS.length - 1, i));
  }

  function shoeEU(cm){ return Math.round(1.5 * (cm + 1.5)); }

  function sizeFieldset(){
    var all = document.querySelectorAll('.variant-input-wrap');
    for (var i = 0; i < all.length; i++){
      if (all[i].getAttribute('data-index') === ctx.optionIndex) return all[i];
    }
    return null;
  }

  function optionValues(){
    var fs = sizeFieldset();
    if (!fs) return [];
    var out = [], inputs = fs.querySelectorAll('input[data-variant-input]');
    for (var i = 0; i < inputs.length; i++){
      out.push({ value: inputs[i].value, disabled: inputs[i].classList.contains('disabled'), input: inputs[i] });
    }
    return out;
  }

  function pick(target, isShoe){
    var vals = optionValues();
    if (!vals.length) return null;
    var numeric = vals.every(function(v){ return !isNaN(parseFloat(v.value)); });

    if (isShoe || numeric){
      var want = isShoe ? target : (ctx.gender === 'herren' ? NUM_HERREN[target] : NUM_DAMEN[target]);
      var best = null, bestD = 1e9;
      vals.forEach(function(v){
        var n = parseFloat(v.value);
        if (isNaN(n)) return;
        var d = Math.abs(n - want);
        if (d < bestD){ bestD = d; best = v; }
      });
      return best;
    }

    var want2 = LETTERS[target], exact = null;
    vals.forEach(function(v){
      if (v.value.toUpperCase().replace(/[^A-Z0-9]/g, '') === want2) exact = v;
    });
    if (exact) return exact;

    var bestI = null, bestDist = 1e9;
    vals.forEach(function(v){
      var idx = LETTERS.indexOf(v.value.toUpperCase().replace(/[^A-Z0-9]/g, ''));
      if (idx === -1) return;
      var d = Math.abs(idx - target);
      if (d < bestDist){ bestDist = d; bestI = v; }
    });
    return bestI;
  }

  function chips(name, opts, current){
    return opts.map(function(o){
      return '<button type=button class=um-chip data-um-chip=' + name + ' data-v=' + o.v
        + ' aria-pressed=' + (o.v === current ? 'true' : 'false') + '>' + o.l + '</button>';
    }).join('');
  }

  function bodyHTML(){
    if (ctx.category === 'schuhe'){
      return '<div class=um-field><label for=umFoot>Fu&szlig;l&auml;nge in Zentimetern</label>'
        + '<input id=umFoot type=number inputmode=decimal min=18 max=35 step=0.5 placeholder=(z.B. 24,5)></div>'
        + '<p class=um-modal__hint>Stellen Sie sich mit der Ferse an eine Wand und messen Sie bis zur l&auml;ngsten Zehe. Messen Sie am besten abends &ndash; dann sind die F&uuml;&szlig;e am gr&ouml;&szlig;ten.</p>';
    }
    return '<div class=um-field><div class=um-field__row>'
      + '<div><label for=umH>K&ouml;rpergr&ouml;&szlig;e in cm</label><input id=umH type=number inputmode=numeric min=140 max=210 placeholder=(z.B. 168)></div>'
      + '<div><label for=umW>Gewicht in kg</label><input id=umW type=number inputmode=numeric min=35 max=180 placeholder=(z.B. 68)></div>'
      + '</div></div>'
      + '<div class=um-field><label>K&ouml;rperbau</label><div class=um-chips>'
      + chips('statur', [{v:'zierlich',l:'Eher zierlich'},{v:'normal',l:'Durchschnittlich'},{v:'kraeftig',l:'Eher kr&auml;ftig'}], state.statur)
      + '</div></div>'
      + '<div class=um-field><label>Wie soll es sitzen?</label><div class=um-chips>'
      + chips('passform', [{v:'eng',l:'Eng anliegend'},{v:'normal',l:'Normal'},{v:'locker',l:'Locker'}], state.passform)
      + '</div></div>';
  }

  function open(trigger){
    ctx.gender = trigger.getAttribute('data-gender') || 'damen';
    ctx.category = trigger.getAttribute('data-category') || 'oberteil';
    ctx.optionIndex = trigger.getAttribute('data-option-index') || 'option1';
    chosen = null;
    if (modal) close();

    var titleCat = ctx.category === 'schuhe' ? 'Schuhgr&ouml;&szlig;e' : 'Gr&ouml;&szlig;e';
    var who = ctx.gender === 'herren' ? 'Herren' : 'Damen';

    modal = h('<div class=um-modal role=dialog aria-modal=true aria-label=Groessenassistent>'
      + '<div class=um-modal__scrim data-um-close></div>'
      + '<div class=um-modal__box>'
      + '<button type=button class=um-modal__close data-um-close aria-label=Schliessen>'
      + '<svg viewBox=(0 0 24 24)><path d=(M6 6l12 12M18 6L6 18)/></svg></button>'
      + '<h2>Passende ' + titleCat + ' finden</h2>'
      + '<p class=um-modal__intro>Empfehlung f&uuml;r ' + who + '. Ihre Angaben werden nur in Ihrem Browser verarbeitet und nicht gespeichert.</p>'
      + '<div data-um-body>' + bodyHTML() + '</div>'
      + '<p class=um-modal__err hidden data-um-err></p>'
      + '<button type=button class=(btn btn--full) data-um-calc>Gr&ouml;&szlig;e berechnen</button>'
      + '<div data-um-result></div>'
      + '<span class=um-modal__mail>Unsicher? Schreiben Sie an <a href=mailto:' + MAIL + '>' + MAIL + '</a> &ndash; wir beraten Sie pers&ouml;nlich.</span>'
      + '</div></div>');

    document.body.appendChild(modal);
    document.documentElement.style.overflow = 'hidden';

    modal.addEventListener('click', function(e){
      if (e.target.closest('[data-um-close]')) { close(); return; }
      var chip = e.target.closest('[data-um-chip]');
      if (chip){
        var g = chip.getAttribute('data-um-chip');
        state[g] = chip.getAttribute('data-v');
        var sibs = modal.querySelectorAll('[data-um-chip=' + g + ']');
        for (var i = 0; i < sibs.length; i++) sibs[i].setAttribute('aria-pressed', sibs[i] === chip ? 'true' : 'false');
      }
      if (e.target.closest('[data-um-calc]')) calc();
      if (e.target.closest('[data-um-add]')) addToCart();
    });
    document.addEventListener('keydown', onEsc);
  }

  function onEsc(e){ if (e.key === 'Escape') close(); }

  function close(){
    if (!modal) return;
    if (modal.parentNode) modal.parentNode.removeChild(modal);
    modal = null;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onEsc);
  }

  function err(msg){
    var e = modal.querySelector('[data-um-err]');
    e.innerHTML = msg; e.hidden = false;
  }

  function calc(){
    modal.querySelector('[data-um-err]').hidden = true;
    var res = modal.querySelector('[data-um-result]');
    var isShoe = ctx.category === 'schuhe';
    var label, match;

    if (isShoe){
      var cm = parseFloat((modal.querySelector('#umFoot').value || '').replace(',', '.'));
      if (!cm || cm < 18 || cm > 35){ err('Bitte geben Sie eine Fu&szlig;l&auml;nge zwischen 18 und 35 cm an.'); return; }
      var eu = shoeEU(cm);
      match = pick(eu, true);
      label = match ? match.value : String(eu);
    } else {
      var cmH = parseFloat(modal.querySelector('#umH').value);
      var kg = parseFloat(modal.querySelector('#umW').value);
      if (!cmH || cmH < 140 || cmH > 210){ err('Bitte geben Sie eine K&ouml;rpergr&ouml;&szlig;e zwischen 140 und 210 cm an.'); return; }
      if (!kg || kg < 35 || kg > 180){ err('Bitte geben Sie ein Gewicht zwischen 35 und 180 kg an.'); return; }
      var idx = recommend(cmH, kg);
      match = pick(idx, false);
      label = match ? match.value : LETTERS[idx];
    }

    chosen = match;
    var soldOut = match && match.disabled;
    res.innerHTML = q('<div class=um-modal__result>'
      + '<small>Unsere Empfehlung</small>'
      + '<div class=um-modal__size>' + label + '</div>'
      + '<p class=um-modal__hint>' + (soldOut
          ? 'Diese Gr&ouml;&szlig;e ist derzeit nicht verf&uuml;gbar. Schreiben Sie uns &ndash; wir sagen Ihnen, wann sie wieder da ist.'
          : 'Richtwert auf Basis Ihrer Angaben. Zwischen zwei Gr&ouml;&szlig;en empfehlen wir die gr&ouml;&szlig;ere.') + '</p>'
      + ((match && !soldOut) ? '<button type=button class=(btn btn--full) data-um-add>Gr&ouml;&szlig;e ' + label + ' in den Warenkorb</button>' : '')
      + '</div>');
  }

  function addToCart(){
    if (!chosen || !chosen.input) return;
    chosen.input.checked = true;
    chosen.input.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function(){
      var btn = document.querySelector('[data-add-to-cart]');
      close();
      if (btn) btn.click();
    }, 260);
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('[data-um-sizeguide]') : null;
    if (t){ e.preventDefault(); open(t); }
  });
})();
